const DND_STORAGE_PREFIX = 'doNotDisturb_';

const DURATION_MS = {
  '15m': 15 * 60 * 1000,
  '1h': 60 * 60 * 1000,
  '8h': 8 * 60 * 60 * 1000,
  '1d': 24 * 60 * 60 * 1000,
  indefinite: Infinity,
};

export const DND_OPTIONS = [
  { value: '15m', label: 'for 15 min' },
  { value: '1h', label: 'for 1h' },
  { value: '8h', label: 'for 8h' },
  { value: '1d', label: 'for 1 day' },
  { value: 'indefinite', label: 'until you change that' },
];

const getSiteStorageKey = (siteId) => (siteId ? `${DND_STORAGE_PREFIX}${siteId}` : null);

export function getDoNotDisturb(siteId) {
  if (!siteId) return null;
  try {
    const storageKey = getSiteStorageKey(siteId);
    const storedDndRecord = localStorage.getItem(storageKey);
    if (!storedDndRecord) return null;
    return JSON.parse(storedDndRecord);
  } catch {
    return null;
  }
}

export function isDoNotDisturb(siteId) {
  if (!siteId) return false;
  const siteDndSetting = getDoNotDisturb(siteId);
  if (!siteDndSetting?.enabled) return false;
  if (siteDndSetting.duration === 'indefinite') return true;
  const elapsedMs = Date.now() - siteDndSetting.enabledAt;
  const durationLimitMs = DURATION_MS[siteDndSetting.duration];
  if (!durationLimitMs || elapsedMs >= durationLimitMs) {
    clearDoNotDisturb(siteId);
    return false;
  }
  return true;
}

export function setDoNotDisturb(duration, siteId) {
  if (!siteId) return;
  const storageKey = getSiteStorageKey(siteId);
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({ enabled: true, duration, enabledAt: Date.now() })
    );
  } catch {
    // Ignore storage errors (e.g. private browsing restrictions)
  }
}

export function clearDoNotDisturb(siteId) {
  if (!siteId) return;
  const storageKey = getSiteStorageKey(siteId);
  try {
    localStorage.removeItem(storageKey);
  } catch {
    // Ignore storage errors
  }
}
